
export const WHATSAPP_NUMBER = "964375968";
export const WHATSAPP_URL = `https://wa.me/51${WHATSAPP_NUMBER}?text=Hola%20DECOMAST,%20deseo%20aprovechar%20la%20oferta%20de%20la%20mesa%20de%20centro`;

// --- SECCIÓN DE IMÁGENES ---
export const IMAGES = {
  hero: "https://res.cloudinary.com/dzkw5p476/image/upload/v1767916413/Gemini_Generated_Image_5oon135oon135oon_j7zncb.png",
  about: "https://res.cloudinary.com/dzkw5p476/image/upload/v1767917674/Gemini_Generated_Image_35x5jy35x5jy35x5_vmmf5d.png",
  gallery: [
    {
      url: "https://res.cloudinary.com/dzkw5p476/image/upload/v1767917490/Gemini_Generated_Image_8qafl58qafl58qaf_d8644p.png",
      tag: "RESISTENCIA"
    },
    {
      url: "https://res.cloudinary.com/dzkw5p476/image/upload/v1767917491/Gemini_Generated_Image_oim6snoim6snoim6_k8c7ri.png",
      tag: "ELEGANCIA"
    },
    {
      url: "https://res.cloudinary.com/dzkw5p476/image/upload/v1767917484/Gemini_Generated_Image_tgdf83tgdf83tgdf_inxz5w.png",
      tag: "CALIDAD"
    }
  ]
};

export const PRODUCT_DETAILS = {
  name: "Mesa de centro de acero inoxidable",
  brand: "DECOMAST",
  priceRegular: "S/ 1100",
  priceOffer: "S/ 650",
  dimensions: "80cm (largo) x 45cm (ancho) x 50cm (alto)",
  specs: [
    "Acero calidad 304 inoxidable de alta resistencia",
    "Tablero superior de vidrio templado de seguridad",
    "Nivel inferior con acabado en espejo",
    "Acabado pulido brillante tipo espejo"
  ]
};
